import { createStore } from 'vuex';

export default createStore({
  state: {
    isAdmin: false,
    isProducer: false,
  },
  mutations: {
    setAdminStatus(state, isAdmin) {
        state.isAdmin = isAdmin;
    },
    setProducerStatus(state, isProducer) {
      state.isProducer = isProducer;
  },
  },
});
